export const QA_NAME_INTEGRATIONS_SOURCE_CARD =
  'rentalPortalIntegrationsSourceCard'

export const QA_NAME_INTEGRATIONS_SOURCE_EDIT =
  'rentalPortalIntegrationsSourceEdit'

export const QA_NAME_INTEGRATIONS_SOURCE_RUN_LOG =
  'rentalPortalIntegrationsSourceRunLog'

export const QA_NAME_INTEGRATIONS_OWNERSHIP =
  'rentalPortalIntegrationsOwnership'

export const QA_NAME_INTEGRATIONS_OWNERSHIP_ENTITY =
  'rentalPortalIntegrationsOwnershipEntity'

export const QA_NAME_INTEGRATIONS_OWNERSHIP_EDIT =
  'rentalPortalIntegrationsOwnershipEdit'

export const QA_NAME_INTEGRATIONS_DATA_SOURCES_RETRY =
  'rentalPortalIntegrationsDataSourcesRetry'

export const IMPORT_POLICY_STATUS = {
  active: 'active',
  error: 'error',
  paused: 'paused',
}

export const IMPORT_POLICY_STATUSES = {
  [IMPORT_POLICY_STATUS.active]: {
    text: 'RentalPortal.IntegrationsSourceStatusActiveKey',
    textColor: 'var(--color-success)',
  },
  [IMPORT_POLICY_STATUS.error]: {
    text: 'RentalPortal.IntegrationsSourceStatusErrorKey',
    textColor: 'var(--color-error)',
  },
  [IMPORT_POLICY_STATUS.paused]: {
    text: 'RentalPortal.IntegrationsSourceStatusPausedKey',
    textColor: 'var(--color-warning)',
  },
}

export const FIELD_OWNERSHIP_OWNER = {
  import: 'import',
  portal: 'portal',
  shared: 'shared',
}

export const FIELD_OWNERSHIP_OWNER_LABEL_KEY = {
  [FIELD_OWNERSHIP_OWNER.portal]:
    'RentalPortal.IntegrationsOwnershipOwnerPortalKey',
  [FIELD_OWNERSHIP_OWNER.shared]:
    'RentalPortal.IntegrationsOwnershipOwnerSharedKey',
}

export const FIELD_OWNERSHIP_PRECEDENCE = {
  holdForReview: 'hold_for_review',
  importWins: 'import_wins',
  portalWins: 'portal_wins',
}

export const FIELD_OWNERSHIP_PRECEDENCE_LABEL_KEY = {
  [FIELD_OWNERSHIP_PRECEDENCE.holdForReview]:
    'RentalPortal.IntegrationsOwnershipPolicyHoldKey',
  [FIELD_OWNERSHIP_PRECEDENCE.importWins]:
    'RentalPortal.IntegrationsOwnershipPolicyImportWinsKey',
  [FIELD_OWNERSHIP_PRECEDENCE.portalWins]:
    'RentalPortal.IntegrationsOwnershipPolicyPortalWinsKey',
}

export const FIELD_OWNERSHIP_ORIGIN = {
  default: 'default',
  tenant: 'tenant',
}

export const FIELD_OWNERSHIP_ORIGINS = {
  [FIELD_OWNERSHIP_ORIGIN.default]: {
    text: 'RentalPortal.IntegrationsOwnershipOriginDefaultKey',
    textColor: 'var(--secondary-text-color)',
  },
  [FIELD_OWNERSHIP_ORIGIN.tenant]: {
    text: 'RentalPortal.IntegrationsOwnershipOriginTenantKey',
    textColor: 'var(--color-info)',
  },
}

export const OWNERSHIP_COLUMN_NAME = {
  Actions: 'actions',
  Entity: 'entity',
  Field: 'field',
  Origin: 'origin',
  Owner: 'owner',
  Precedence: 'shared_precedence',
}

export const OWNERSHIP_ACTIONS_COLUMN_WIDTH = 72

export const OWNERSHIP_COLUMNS_CONFIG = {
  [OWNERSHIP_COLUMN_NAME.Actions]: {
    index: 5,
    name: OWNERSHIP_COLUMN_NAME.Actions,
    ordering_field: null,
    title: null,
    visible: true,
    width: OWNERSHIP_ACTIONS_COLUMN_WIDTH,
  },
  [OWNERSHIP_COLUMN_NAME.Entity]: {
    index: 0,
    name: OWNERSHIP_COLUMN_NAME.Entity,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsOwnershipEntityColumnKey',
    visible: true,
    width: 140,
  },
  [OWNERSHIP_COLUMN_NAME.Field]: {
    index: 1,
    name: OWNERSHIP_COLUMN_NAME.Field,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsOwnershipFieldColumnKey',
    visible: true,
    width: 200,
  },
  [OWNERSHIP_COLUMN_NAME.Origin]: {
    index: 4,
    name: OWNERSHIP_COLUMN_NAME.Origin,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsOwnershipOriginColumnKey',
    visible: true,
    width: 130,
  },
  [OWNERSHIP_COLUMN_NAME.Owner]: {
    index: 2,
    name: OWNERSHIP_COLUMN_NAME.Owner,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsOwnershipOwnerColumnKey',
    visible: true,
    width: 200,
  },
  [OWNERSHIP_COLUMN_NAME.Precedence]: {
    index: 3,
    name: OWNERSHIP_COLUMN_NAME.Precedence,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsOwnershipPolicyColumnKey',
    visible: true,
    width: 240,
  },
}

export const OWNERSHIP_PAGE_SIZE = 20

export const OWNERSHIP_SKELETON_ROWS = 8

export const OWNERSHIP_ENTITY_ALL = 'all'
